import { axiosInstance } from "./config";

export default {
  state: {
    article: {},
  },
  mutations: {
    SetArticle(state, payload) {
      state.article = payload;
    },
  },
  actions: {
    async Get_Article({ commit }, payload) {
      if (!payload) {
        payload = "/1";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/articles${payload}`)
        .then(function (data) {
          commit("SetArticle", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_Article(commit, payload) {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/article", payload, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_Article(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/article/" + payload.id, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_Article(commit, payload) {
      return await axiosInstance
        .delete("/article/" + payload.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_article: (state) => state.article,
  },
};
